import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { BaseComment } from '../../models/base/base-comment';
import { UserProfileBadgeComponent } from '../../views/shared/components/user-profile-badge/user-profile-badge.component';

@Component({
  selector: 'app-comment',
  standalone: true,
  imports: [UserProfileBadgeComponent],
  templateUrl: './comment.component.html',
  styleUrls: ['./comment.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CommentComponent {
  @Input() comment!: BaseComment;
}
